import styled from "styled-components";

export const InputCodeStepWrapper = styled.div`
    button {
      margin-top: 10px;
    }
`;